/**
 * The CSS class names the views are built from.
 *
 * These live in the application, not in `@juis/`: the framework knows nothing about Bulma and
 * may not learn it. Names mirror the class itself; where a Bulma class shares its name with an
 * HTML tag constant from `@juis/components`, the constant is suffixed with `_CLASS` so both can
 * be imported into the same file.
 */

// Navbar
export const NAVBAR = "navbar";
export const NAVBAR_BRAND = "navbar-brand";
export const NAVBAR_BURGER = "navbar-burger";
export const NAVBAR_DIVIDER = "navbar-divider";
export const NAVBAR_DROPDOWN = "navbar-dropdown";
export const NAVBAR_END = "navbar-end";
export const NAVBAR_ITEM = "navbar-item";
export const NAVBAR_LINK = "navbar-link";
export const NAVBAR_MENU = "navbar-menu";
export const NAVBAR_START = "navbar-start";

// Layout
export const SECTION_CLASS = "section";
export const CONTAINER = "container";
export const COLUMNS = "columns";
export const COLUMN = "column";
export const HERO = "hero";
export const HERO_BODY = "hero-body";
export const FOOTER = "footer";
export const BOX = "box";
export const CONTENT = "content";
export const MEDIA = "media";
export const MEDIA_CONTENT = "media-content";
export const MEDIA_LEFT = "media-left";
export const TITLE = "title";
export const SUBTITLE = "subtitle";
export const IMAGE = "image";
export const ICON = "icon";
export const NOTIFICATION = "notification";

// Cards
export const CARD = "card";
export const CARD_IMAGE = "card-image";
export const CARD_CONTENT = "card-content";
export const CARD_HEADER = "card-header";
export const CARD_HEADER_TITLE = "card-header-title";
export const CARD_FOOTER = "card-footer";
export const CARD_FOOTER_ITEM = "card-footer-item";

// Buttons
export const BUTTON_CLASS = "button";
export const BUTTONS = "buttons";

// Forms
export const FIELD = "field";
export const LABEL_CLASS = "label";
export const CONTROL = "control";
export const INPUT_CLASS = "input";
export const SELECT_CLASS = "select";
export const TEXTAREA_CLASS = "textarea";
export const CHECKBOX = "checkbox";
export const HELP = "help";

// Modals
export const MODAL = "modal";
export const MODAL_BACKGROUND = "modal-background";
export const MODAL_CARD = "modal-card";
export const MODAL_CARD_HEAD = "modal-card-head";
export const MODAL_CARD_TITLE = "modal-card-title";
export const MODAL_CARD_BODY = "modal-card-body";
export const MODAL_CARD_FOOT = "modal-card-foot";
export const DELETE = "delete";

// Progress
export const PROGRESS_CLASS = "progress";

// Tags
export const TAG = "tag";
export const TAGS = "tags";

// Colours
export const IS_PRIMARY = "is-primary";
export const IS_LINK = "is-link";
export const IS_INFO = "is-info";
export const IS_SUCCESS = "is-success";
export const IS_WARNING = "is-warning";
export const IS_DANGER = "is-danger";
export const IS_LIGHT = "is-light";
export const IS_DARK = "is-dark";

// Sizes
export const IS_SMALL = "is-small";
export const IS_MEDIUM = "is-medium";
export const IS_LARGE = "is-large";
export const IS_4BY3 = "is-4by3";
export const IS_64X64 = "is-64x64";

// State and modifiers
export const IS_ACTIVE = "is-active";
export const IS_HIDDEN = "is-hidden";
export const IS_HOVERABLE = "is-hoverable";
export const IS_LOADING = "is-loading";
export const IS_FULLWIDTH = "is-fullwidth";
export const IS_ROUNDED = "is-rounded";
export const IS_OUTLINED = "is-outlined";
export const IS_MULTILINE = "is-multiline";
export const IS_ONE_THIRD = "is-one-third";
export const IS_NARROW = "is-narrow";
export const IS_RIGHT = "is-right";
export const IS_CENTERED = "is-centered";

// Layout helpers
export const IS_FIXED_TOP = "is-fixed-top";
export const HAS_NAVBAR_FIXED_TOP = "has-navbar-fixed-top";
export const HAS_DROPDOWN = "has-dropdown";
export const HAS_SHADOW = "has-shadow";

// Flex helpers
export const IS_FLEX = "is-flex";
export const IS_JUSTIFY_CONTENT_SPACE_BETWEEN = "is-justify-content-space-between";
export const IS_ALIGN_ITEMS_CENTER = "is-align-items-center";

// Typography helpers
export const HAS_TEXT_CENTERED = "has-text-centered";
export const HAS_TEXT_WEIGHT_BOLD = "has-text-weight-bold";
export const HAS_TEXT_GREY = "has-text-grey";

// Spacing helpers
export const MB_2 = "mb-2";
export const MB_3 = "mb-3";
export const MB_4 = "mb-4";
export const MT_2 = "mt-2";
export const MT_3 = "mt-3";
export const P_4 = "p-4";
export const MX_AUTO = "mx-auto";

// Font Awesome
export const FAS = "fas";
export const faIcon = (name: string): string => `fa-${name}`;
